class ProductGiftOverlay extends HTMLElement {
  constructor() {
    super();

    this.setNodes();
    this.setEvents();
    this.displayOverlayOnLoad();
  }

  setNodes() {
    this.overlaySection = this.querySelector('.js-gift-product-overlay');
    this.overlayBtn = this.querySelector('.js-gift-overlay-btn');
    this.closeButton = this.querySelector('.js-gift-product-close');
  }

  setEvents() {
    if (this.overlayBtn) {
      this.overlayBtn.addEventListener('click', function(){
        this.openOverlay();
        trapFocus(this.overlaySection, this.closeButton);
      }.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', function(){
        this.closeOverlay();
      }.bind(this));
    }
  }

  closeOverlay() {
    if( this.overlaySection &&
      !this.overlaySection.classList.contains('hidden') ) {
      this.overlaySection.classList.add('hidden');
    }
  }

  openOverlay() {
    if( this.overlaySection &&
      this.overlaySection.classList.contains('hidden') ) {
      this.overlaySection.classList.remove('hidden');
    }
  }

  displayOverlayOnLoad() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.show_gift_overlay) {
      this.openOverlay();
    }
  }
}

customElements.define('product-gift-overlay', ProductGiftOverlay);
